module.exports = require("redux-thunk");


//////////////////
// WEBPACK FOOTER
// external "redux-thunk"
// module id = 17
// module chunks = 0